exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui.small.avatar.image {\n  margin: auto; }\n\n.main-gbacademy p {\n  margin: 1.4em 1em !important; }\n\n.main-gbacademy p.lesson-menu {\n  margin: 1.4em 1em !important; }\n\n.main-gbacademy .container {\n  margin-top: 50px; }\n\n.main-gbacademy h2 {\n  border: 1px solid #fff;\n  padding: 10px;\n  border-radius: 3px;\n  font-size: 33px;\n  margin: 0 -15px !important; }\n\n@media only screen and (max-width: 767px) {\n  .main-gbacademy .ui.container.stackable.two.column.grid.Main-GBAcademy-grid {\n    margin-left: auto !important;\n    margin-right: auto !important; }\n  .main-gbacademy h2 {\n    font-size: 23px; } }\n\n.main-gbacademy .ui.container.stackable.two.column.grid.Main-GBAcademy-grid .column {\n  padding: 5px !important;\n  margin-top: 20px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/organisms/MainGbAcademy/MainGbAcademy.scss
// module id = 1300
// module chunks = 0